import { themedStyled } from 'common/styles/styletron.theme';
import Link from 'next/link';

export const TableStyle = themedStyled('div', {
  padding: '8px 0 0 8px',
  display: 'block',
  fontSize: '0.85rem',
  overflow: 'scroll',
});

const thtd = {
  verticalAlign: 'top',
  margin: '10px 12px',
  padding: '0.5rem 0.75rem',
};

export const Table = themedStyled('table', {
  borderSpacing: 0,
  // border: '1px solid #dedede',
  borderCollapse: 'separate',
  // borderRadius: '6px'
  // flexGrow: 1,
  // position: 'relative',
});

export const Tbody = themedStyled('tbody', {
  height: '100%',
  width: '100%',
});

export const Th = themedStyled('th', {
  ...thtd,
  fontWeight: 'normal',
  backgroundColor: 'white',
  borderBottom: '1px solid #dedede',
  position: 'relative',
  textAlign: 'left',
});

export const Td = themedStyled('td', {
  ...thtd,
  whiteSpace: 'nowrap',
  borderTop: '1px solid #f2f2f2',
  '& > .--aggregate': {
    backgroundColor: '#EFF6FC',
    fontWeight: '600',
  },
});

export const Thead = themedStyled('thead', {
  position: 'sticky',
  top: 0,
});

export const CardContainer = themedStyled('div', {
  margin: '.75rem .1rem',
  borderRadius: '8px',
  boxShadow: '0 2px 12px rgb(14 31 80 / 10%)',
  padding: '.8rem 1rem',
  backgroundColor: 'white',
  position: 'relative',
});

export const PivotList = themedStyled('div', {
  position: 'relative',
});

export const IconDrag = themedStyled('div', {
  position: 'absolute',
  right: '1rem',
  top: 'calc(50% - 15px)',
  color: '#484848',
  fontSize: '22px',
});

export const LinkText = themedStyled(Link, {
  color: 'blue',
  textDecoration: 'underline',
  cursor: 'pointer',
  userSelect: 'none',
});
